import { Box, Button, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

export default function Bloque3({ text3, handleDatosTextField3 }) {

    useEffect(() => {
        console.log(text3)
    }, [text3])


    const [mostrar, setMostrar] = useState(false)

    const handleMostrar = () => {
        setMostrar(!mostrar)
    }

    return (
        <div style={{  }}>

            <Box style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography style={{ fontSize: "17px", marginTop: "20px" }} ><b>Queratometrías</b></Typography>
                <Button variant='outlined' style={{ marginTop: "20px" }} onClick={handleMostrar}>{mostrar ? "Ocultar Valores" : "Mostrar Valores"}</Button>
            </Box>
            {
                mostrar && 
                <TableContainer style={{ marginTop: "20px", marginBottom: "20px" }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ fontSize: "16px", color: "transparent" }} align="left"><b>T.</b></TableCell>
                            <TableCell style={{ fontSize: "16px" }} align="center"><b>K1</b></TableCell>
                            <TableCell style={{ fontSize: "16px" }} align="center"><b>EJE1</b></TableCell>
                            <TableCell style={{ fontSize: "16px", color: "transparent" }} align="left"><b>T.</b></TableCell>
                            <TableCell style={{ fontSize: "16px" }} align="center"><b>K2</b></TableCell>
                            <TableCell style={{ fontSize: "16px" }} align="center"><b>EJE2</b></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            text3.map((x, ix) =>
                                <TableRow style={{ display: (x.id === "gafas" || x.id === "lentesContacto") ? "none" : null }} key={ix} hover>
                                    <>
                                        <TableCell align="left">
                                            <Typography>
                                                {x.label}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <TextField
                                                type={"number"}
                                                value={x.k1}
                                                onChange={(e) => handleDatosTextField3(x.id, e.target.value, 'k1')}
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            <TextField
                                                type={"number"}
                                                value={x.eje1}
                                                onChange={(e) => handleDatosTextField3(x.id, e.target.value, 'eje1')}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography color={"transparent"}>
                                                {x.label}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <TextField
                                                type={"number"}
                                                value={x.k2}
                                                onChange={(e) => handleDatosTextField3(x.id, e.target.value, 'k2')}
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            <TextField
                                                type={"number"}
                                                value={x.eje2}
                                                onChange={(e) => handleDatosTextField3(x.id, e.target.value, 'eje2')}
                                            />
                                        </TableCell>
                                    </>
                                </TableRow>
                            )
                        }
                    </TableBody>
                </Table>

            </TableContainer>}

            <Divider style={{ marginTop: "15px" }} />
        </div>
    )
}
